import React from 'react';
import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
  { id: 'reports', label: 'Reports', glyph: '≡', to: '/v2', end: true, kbd: '⌘1' },
  { id: 'upload',  label: 'Upload',  glyph: '↑', to: '/v2/upload',  kbd: '⌘2' },
  { id: 'overall', label: 'Overall', glyph: '⊞', to: '/v2/overall', kbd: '⌘3' },
  { id: 'master',  label: 'Master',  glyph: '★', to: '/v2/master',  kbd: '⌘4' },
  { id: 'configs', label: 'Configs', glyph: '⚙', to: '/v2/configs', kbd: '⌘5' },
];

export default function NavRail() {
  return (
    <nav className="navrail">
      <div className="nav-brand">X</div>
      {NAV_ITEMS.map((it) => (
        <NavLink
          key={it.id}
          to={it.to}
          end={it.end}
          className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          title={`${it.label}  ${it.kbd}`}
        >
          <span className="g">{it.glyph}</span>
          <span className="l">{it.label}</span>
        </NavLink>
      ))}
      <div style={{ flex: 1 }} />
      <NavLink to="/" className="nav-item" title="Switch to old design">
        <span className="g">↩</span>
        <span className="l">v1</span>
      </NavLink>
    </nav>
  );
}
